export default __webpack_public_path__ + "static/media/importsPage1Light.851a76d1.png";